import { ICargo } from '../entities/cargoes'
import { stacks } from '../entities/stacks-sidecar'
import { distance } from '../lib/distance-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask, ITaskType, registerTask } from './jobs'
import { jobs } from './jobs-sidecar'

const type: ITaskType = 'unstack-cargo'
export const register = () => registerTask(type, runTask)

export function createTask_unstackCargo(
  i: number,
  j: number,
  targetCargo: ICargo,
): ITask {
  return jobs._createTask(i, j, type, {
    targetCargo,
  })
}

function runTask(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, type)
  let m = jobLogger.assertReserved(job)
  jobLogger.assertNotNil(job.targetCargo)
  let ca = job.targetCargo

  // Are we at the right spot?
  if (!distance.isAt(m.i, m.j, task.i, task.j)) {
    return jobLogger.failTask(job, task, 'wrong spot')
  }

  let stackHere = stacks.findAtSpot(m.i, m.j, (c) => true)
  // Stack went missing
  if (!stackHere) {
    return jobLogger.failTask(job, task, 'stack lost spot')
  }

  if (!distance.isAt(m.i, m.j, ca.i, ca.j)) {
    return jobLogger.failTask(job, task, 'cargo isnt here')
  }

  monsters.pickupCargo(m, ca)
  monsters.dropCargo(m)
  // Should probably put this down now

  return jobLogger.succeedTask(job, task)
  // TODO: check to make sure there's a cargo here of the correct type, and put it in the stack
  // task.isComplete = true
}
